/* global grecaptcha */
// ダウンロード素材ページ: ダウンロード時にreCAPTCHA v3のトークンを取得してから送信する
// トークンの有効期限は2分のため、ページ表示時ではなくボタン押下のたびに取得する
document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll('form[data-role="material-download"]');
  if (!forms.length) return;

  forms.forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (typeof grecaptcha === 'undefined') return;

      const { siteKey, recaptchaAction } = form.dataset;
      grecaptcha.ready(() => {
        grecaptcha.execute(siteKey, { action: recaptchaAction }).then((token) => {
          form.querySelector('input[data-role="recaptcha-token"]').value = token;
          form.submit();
        });
      });
    });
  });
});
